import { Component, computed, inject, input, signal } from '@angular/core';
import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { filter, timer } from 'rxjs';

@Component({
  selector: 'app-text-carousel',
  imports: [TranslatePipe],
  templateUrl: './text-carousel.html',
  styleUrl: './text-carousel.scss',
})
export class TextCarousel {
  readonly tipsTexts = input.required<string[]>();

  protected readonly currentIndex = signal(0);
  protected readonly total = computed(() => this.tipsTexts().length);
  protected readonly progressBarLength = computed(() => `${Math.floor(((this.currentIndex() + 1) / this.total()) * 100)}%`);
  private paused = false;

  constructor() {
    timer(1000, 5000)
      .pipe(
        filter(() => !this.paused),
        takeUntilDestroyed(inject(DestroyRef)),
      )
      .subscribe(() => this.next());
  }

  next() {
    this.currentIndex.update((index) => (index + 1) % this.total());
  }

  previous() {
    this.currentIndex.update((index) => (index === 0 ? this.total() - 1 : index - 1));
  }

  pause() {
    this.paused = true;
  }

  unpause() {
    this.paused = false;
  }
}
